<main class="main-root">
    <section class="pricing-plan-section">
        <div class="container">
            <div class="pricing-plan-dv">
                <div class="pricing-plan-left">
                    <div class="pricing-plan-card plan-card1">
                        <h3>{{ 'Your Starter Kit' | translate }}</h3>    
                        <div class="pricing-plan-row">
                            <div class="plan-checklist-dv">
                                <ul class="plan-checklist1">
                                    <li>{{ 'Business Listing' | translate }}</li>
                                    <li>{{ '1 Promotion slot' | translate }}</li>
                                    <li>{{ '1 Digital Voucher' | translate }}</li>
                                    <li>{{ 'Loyalty points' | translate }}</li>
                                </ul>
                            </div>
                            <div class="pln-free-dv">
                                <h2>{{ 'FREE' | translate }}</h2>
                                <p>{{ 'to use' | translate }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="pricing-plan-card plan-card2">
                        <h3>{{ 'Your Growth Kit' | translate }} <span *ngIf="selectedCombination" style="display: inline;">{{ selectedCombination }}</span></h3>
                        <div class="pricing-plan-row">
                          <div class="plan-checklist-dv">
                            <ul class="plan-checklist-round">
                              <li [class.active]="optionASelected" (click)="toggleOption('A')">
                                <span class="txt">{{ '3 slots Promo' | translate }}</span>
                                <span class="price-span">
                                  <span class="strike-span">300K</span>
                                  <b>{{ currentPrices.A | shortPrice }}</b>
                                </span>
                              </li>
                              <li [class.active]="optionBSelected" (click)="toggleOption('B')">
                                <span class="txt">{{ 'Unlimited Promo' | translate }}</span>
                                <span class="price-span">
                                  <span class="strike-span">450K</span>
                                  <b>{{ currentPrices.B | shortPrice }}</b>
                                </span>
                              </li>
                              <li [class.active]="optionCSelected" (click)="toggleOption('C')">
                                <span class="txt">{{ 'Order at Table' | translate }}</span>
                                <span class="price-span">
                                  <span class="strike-span">300K</span>
                                  <b>{{ currentPrices.C | shortPrice }}</b>
                                </span>
                              </li>
                            </ul>
                          </div>
                      
                          <div class="sub-tab-root">
                            <h5>{{ 'Subscription' | translate }}</h5>
                            <div class="price-sub-tab-root">
                              <div class="price-sub-tab">
                                <button class="btn btn-sub" [ngClass]="{'active': subscriptionType === 'annually'}" (click)="setSubscription('annually')">{{ 'Annually' | translate }}</button>
                                <button class="btn btn-sub" [ngClass]="{'active': subscriptionType === 'quarterly'}" (click)="setSubscription('quarterly')">{{ 'Quarterly' | translate }}</button>
                                <button class="btn btn-sub" [ngClass]="{'active': subscriptionType === 'monthly'}" (click)="setSubscription('monthly')">{{ 'Monthly' | translate }}</button>
                              </div>
                              <div class="price-sub-dv">
                                <h4 [style.opacity]="currentPrices.discount !== 'No Disc' ? 1 : 0">{{ currentPrices.discount }}</h4>
                                <div class="price-text">{{ currentPrices.total | shortPrice }}<small>/{{ 'mth' | translate }}</small></div>
                              </div>
                            </div>
                            <div class="btn-dv">
                              <button class="btn btn-secondary-common" (click)="openGetInTouchModal('growth')">{{ 'GROW YOUR BIZ NOW' | translate }}</button>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>

                <div class="pricing-plan-right">
                    <div class="pricing-plan-card plan-card3">
                        <h3>{{ 'Your Premium Kit' | translate }}</h3>

                        <ul class="premium-kit-list-status">
                            <li> <span class="status-dot reach-dot"></span> <span>{{ 'Reach' | translate }}</span></li>
                            <li> <span class="status-dot engagement-dot"></span> <span>{{ 'Engagement' | translate }}</span></li>
                            <li> <span class="status-dot loyalty-dot"></span> <span>{{ 'Loyalty' | translate }}</span></li>
                        </ul>

                        <div class="premium-kit-list">
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Enhanced Directory' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Slot in HUNGERY home banner' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span> <span class="status-dot engagement-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Ads space in website' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span> <span class="status-dot engagement-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Mention in news' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Food and Outlet photography' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Loyalty program consultation' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span> <span class="status-dot loyalty-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Push / Email campaigns' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span> <span class="status-dot loyalty-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Enhanced promotion' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span> <span class="status-dot engagement-dot"></span> <span class="status-dot loyalty-dot"></span></div>
                            </div>
                            <div class="premium-kit-list-li">
                                <div class="txt-dv">{{ 'Premium Insights' | translate }}</div>
                                <div class="dot-dv"><span class="status-dot reach-dot"></span> <span class="status-dot loyalty-dot"></span></div>
                            </div>
                        </div>

                        <div class="btn-dv">
                            <button class="btn btn-secondary-common" (click)="openGetInTouchModal('premium')">{{ 'GET IN TOUCH FOR' | translate }} <br> {{ 'PREMIUM UPGRADE' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>